module.exports = __webpack_public_path__ + "img/34-05ef1c.png";